<template>
  <div class="content">
    <div class="main_content">
      <div class="content_left">
        <div class="left_title" @click="titleClick">
          <div class="left_title_icon">
            <div v-show="showNavFlag" class="left_title_icon_tri_on"></div>
            <div v-show="!showNavFlag" class="left_title_icon_tri_off"></div>
          </div>
          <div class="left_title_text">我的练习</div>
        </div>
        <transition
          enter-active-class="animated fadeInDown"
          leave-active-class="animated fadeOutUp"
        >
          <div v-show="showNavFlag" class="left_tabs">
            <div class="left_nav" @click="allPractice">
              <div
                class="nav_content"
                :class="activeNav == 'all' ? 'navActive' : ''"
              >
                <div class="nav_text">
                  所有练习题（{{ practiceList.length }}）
                </div>
              </div>
            </div>
            <div class="left_nav" @click="clearPractice">
              <div
                class="nav_content"
                :class="activeNav == 'clear' ? 'navActive' : ''"
              >
                <div class="nav_text">清空所有练习题</div>
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="content_right">
        <div class="right_top" v-if="practiceList.length == 0">
          <div class="topic_type">
            <div class="type_text">暂无练习</div>
          </div>
        </div>
        <div class="right_top" v-else>
          <div class="topic_type">
            <div class="type_text">所有练习</div>
            <div class="type_line"></div>
          </div>
          <div class="practice_list">
            <div
              class="practice_wrap"
              v-for="(item, index) in practiceList"
              :key="index"
            >
              <div class="close_btn" @click="deletePracticeFun(item, index)">
                <img src="../assets/images/close_icon.png" alt="" />
              </div>
              <div class="practice_title">{{ item.paper_name }}</div>
              <div class="practice_operation">
                <div class="practice_msg">
                  得分：<span>{{ item.score }}</span>
                </div>
                <router-link
                  :to="{ path: '/home', query: { id: item.paper_id } }"
                  class="operation_btn"
                  >去学习</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPracticeList } from "@/api/paper.js";
import { deletePractice } from "@/api/paper.js";
import { clearPractice } from "@/api/paper.js";
export default {
  name: "home",
  data() {
    return {
      showNavFlag: true,
      activeNav: "all",
      practiceListData: {
        token: "",
        limit: 100,
        offset: 0,
        user_id: "",
        status: 0,
      },
      practiceList: [],
      deletepracticeData: {
        token: "",
        user_id: "",
        exmain_key: "",
        paper_id: "",
      },
      clearpracticeData: {
        token: "",
        user_id: "",
      },
    };
  },
  mounted() {
    let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.practiceListData.token = window.localStorage.getItem("token");
    this.practiceListData.user_id = userInfo.user_id;
    this.deletepracticeData.token = window.localStorage.getItem("token");
    this.deletepracticeData.user_id = userInfo.user_id;
    this.clearpracticeData.token = window.localStorage.getItem("token");
    this.clearpracticeData.user_id = userInfo.user_id;
    this.allPractice();
  },
  methods: {
    //我的练习点击
    titleClick() {
      this.showNavFlag = !this.showNavFlag;
    },
    //所有练习题
    allPractice() {
      let that = this;
      let data = this.practiceListData;
      getPracticeList(data).then((res) => {
        if (res.code == 0) {
          that.practiceList = res.data;
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //删除练习
    deletePracticeFun(item, index) {
      let that = this;
      this.deletepracticeData.exmain_key = item.exmain_key;
      this.deletepracticeData.paper_id = item.paper_id;
      let data = this.deletepracticeData;
      deletePractice(data).then((res) => {
        if (res.code == 0) {
          that.practiceList.splice(index, 1);
          that.$message.success(res.message);
        } else {
          that.$message.error(res.message);
        }
      });
    },
    //清空练习题
    clearPractice() {
      this.activeNav = "clear";
      let that = this;
      let data = this.clearpracticeData;
      clearPractice(data).then((res) => {
        if (res.code == 0) {
          that.$message.success(res.message);
        } else {
          that.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  height: calc(100% - 210px);
  background-color: #f1f1f1;
  padding: 115px 0 15px;
}
.main_content {
  width: 1210px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-y: scroll;
  overflow-x: hidden;
}
.content_left {
  width: 298px;
  height: auto;
  min-height: calc(100% - 2px);
  border: 1px solid #d7d7d7;
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
}
.content_left .left_title {
  width: 298px;
  height: 53px;
  background-color: #8e0001;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  z-index: 9;
}
.content_left .left_title .left_title_icon {
  width: 24px;
  height: 24px;
  background-color: #a7051c;
  border-radius: 50%;
  margin-left: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.content_left .left_title .left_title_icon .left_title_icon_tri_on {
  width: 10px;
  height: 6px;
  background-image: url("../assets/images/tri_on.png");
}
.content_left .left_title .left_title_icon .left_title_icon_tri_off {
  width: 6px;
  height: 10px;
  background-image: url("../assets/images/tri_off.png");
}
.content_left .left_title .left_title_text {
  font-size: 18px;
  color: #ffffff;
  margin-left: 18px;
}
.content_left .left_tabs {
  width: 298px;
  height: auto;
  display: flex;
  flex-direction: column;
}
.fadeInDown {
  animation: 0.8s animationIn;
}

@keyframes animationIn {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
.fadeOutUp {
  animation: 0.8s animationOut;
}
@keyframes animationOut {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}
.content_left .left_tabs .left_nav {
  width: 298px;
  height: auto;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #d7d7d7;
}
.content_left .left_tabs .left_nav .nav_content {
  width: 298px;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.content_left .left_tabs .nav_content:last-child {
  border-bottom: none;
}
.content_left .left_tabs .nav_content .nav_text {
  width: 200px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #343434;
  text-align: left;
  margin-left: 68px;
}
.content_left .left_tabs .nav_content.navActive {
  background-color: #b93132;
}
.content_left .left_tabs .nav_content.navActive .nav_text {
  color: #f7fffe;
}
.content_right {
  width: 884px;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-left: 15px;
}
.right_top {
  width: 884px;
  height: auto;
  border: 1px solid #d7d7d7;
  background-color: #fefefe;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 0 29px;
}
.right_top .topic_type {
  width: 833px;
  height: 45px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 22px;
}
.right_top .topic_type .type_text {
  width: 833px;
  height: 43px;
  line-height: 43px;
  font-size: 18px;
  color: #030303;
  text-align: left;
}
.right_top .topic_type .type_line {
  width: 28px;
  height: 2px;
  background-color: #d7112c;
}
.right_top .practice_list {
  width: 820px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.right_top .practice_wrap {
  width: 728px;
  height: auto;
  padding: 13px 64px 13px 28px;
  background-color: #f1f1f1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 15px;
}
.right_top .practice_wrap .close_btn {
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 18px;
}
.right_top .practice_wrap .practice_title {
  width: 729px;
  height: auto;
  font-size: 14px;
  color: #474747;
  line-height: 28px;
  margin-bottom: 7px;
  margin-top: 7px;
  text-align: left;
}
.right_top .practice_wrap .practice_operation {
  width: 729px;
  height: 37px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}
.right_top .practice_wrap .practice_operation .practice_msg {
  width: 500px;
  text-align: left;
  font-size: 14px;
  color: #474747;
}
.right_top .practice_wrap .practice_operation .practice_msg span {
  font-size: 16px;
  color: #d6102a;
}
.right_top .practice_wrap .practice_operation .operation_btn {
  width: 108px;
  height: 37px;
  background-color: #ff8d31;
  text-align: center;
  line-height: 37px;
  color: #ffffff;
  font-size: 18px;
  border-radius: 2px;
  cursor: pointer;
}
.right_top .practice_wrap .practice_operation .operation_btn_special {
  background-color: #d6102b;
}
.main_content::-webkit-scrollbar {
  width: 8px;
}
.main_content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
  background: #e2e2e2;
}
.main_content::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  background: #f1f1f1;
}
</style>
